import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import PersonIcon from "@mui/icons-material/Person";
import "./contact.css";
import axios from "axios";
import { connect } from "react-redux";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdModeEdit } from "react-icons/md";
import { setDialedNumberInc } from "../../Redux/Actions/actions";
import {
  AvcUrl,
  BaseUrl,
  VeichleBaseUrl,
} from "../../Container/BaseUrl/BaseUrl";
import { AiOutlineUserDelete } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { AiOutlineFieldNumber } from "react-icons/ai";
import { HiOutlineMail } from "react-icons/hi";
import { HiMiniDevicePhoneMobile } from "react-icons/hi2";
import { MdOutlinePhone } from "react-icons/md";
import { BsBuilding } from "react-icons/bs";
import { TbBuildingBank } from "react-icons/tb";
import { FaRegEye } from "react-icons/fa";
import CardContent from "@mui/material/CardContent";
import Drawer from "@mui/material/Drawer";
import Nointeractions2 from "../../Assets/images/svg/No-interactions2.svg";
import {
  At,
  House,
  MapPin,
  Pencil,
  Phone,
  UserCircle,
  WhatsappLogo,
  IdentificationBadge,
  ListNumbers,
  Eye,
} from "@phosphor-icons/react";
import {
  Stack,
  Button,
  Typography,
  Pagination,
  Paper,
  Fab,
  Box,
  Grid,
  Avatar,
  IconButton,
  TextField,
} from "@mui/material";
import AddCustomer from "./AddCustomer";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import NoSelectContact from "../../Assets/images/svg/nouserdata.svg";
import EditCustomer from "./EditCustomer";
import { toast } from "react-toastify";
import { randomColors } from "../../Utils/colorpallet";
import SessionHistory from "./SessionHistory";
import WhatsAppInitDialogBox from "./WhatsAppInitDialogBox";
import { useDebounce } from "./hooks";
import { toaststyle } from "../../Utils/toaststyle";
import {
  MdLocationCity,
  MdEditLocationAlt,
  MdOutlineEditLocation,
  MdEmail,
  MdOutlineMarkEmailRead,
  MdCall,
} from "react-icons/md";

import { IoMdGlobe } from "react-icons/io";
import { Card } from "@material-ui/core";
import { Modal, Spinner } from "react-bootstrap";

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  padding: "5px 5px 0px 5px",
  background: "none",
  boxShadow: "none",
  borderRadius: "none",
  overflow: "hidden",
}));
const mapStateToProps = (state) => {
  return { skillset: state.data.skillset };
};

const CustomerDetails = () => {
  const [searchvalue, setsearchvalue] = useState("");
  const [contactList, setContactList] = useState([]);
  const [showEditCustomer, setsetshowEditCustomer] = useState(false);
  const [selectedUser, setselectedUser] = useState([]);
  const [selectedIndex, setselectedIndex] = useState();
  const [showTab, setshowTab] = useState("Overview");
  const [showUserContactDetail, setshowUserContactDetail] = useState(false);
  const [whatsappOpenDialog, setwhatsappOpenDialog] = useState(false);
  const [editmobilenumber, seteditmobilenumber] = useState("");
  const [veichledetailsdata, setveichledetailsdata] = useState([]);
  const [veichledetailsdatamodal, setveichledetailsdatamodal] = useState("");
  const [veichledetailsdatamodalloader, setveichledetailsdatamodalloader] = useState(false);
  const [firstZeroSearch, setFirstZeroSearch] = useState(true);
  const [firstLargeSearch, setFirstLargeSearch] = useState(true);
  const [mobileeditmodal, setMobileEditmodal] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const debouncedSearch = useDebounce(searchvalue);
  console.log("debouncedSearch", debouncedSearch);
  const handleChange = (event, value) => {
    setPage(value);
  };
  const whatsappDialogClose = () => {
    setwhatsappOpenDialog(false);
  };

  const handelOpenmobileeditmodal = () => {
    setMobileEditmodal(true);
  };

  const handelClosemobileeditmodal = () => {
    setMobileEditmodal(false);
  };

  useEffect(() => {
    if (searchvalue.length > 2) {
      if (firstLargeSearch) {
        setPage(1);
        setFirstLargeSearch(false);
      }
      getcustomerdetails();
    } else if (searchvalue.length === 0) {
      if (firstZeroSearch) {
        setPage(1);
        setFirstZeroSearch(false);
      }
      listContact();
    }
  }, [debouncedSearch, page]);

  useEffect(() => {
    if (searchvalue.length === 0) {
      setFirstZeroSearch(true);
    } else if (searchvalue.length > 2) {
      setFirstLargeSearch(true);
    }
  }, [searchvalue]);

  useEffect(() => {
    if (selectedUser && selectedUser.customerNumber) {
      VeichleDetailsApi();
    }
  }, [selectedUser]);

  const listContact = () => {
    axios
      .post(
        VeichleBaseUrl + "/Listcustomer",
        { offset: page == 1 ? 0 : (page - 1) * 10, limit: 10 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setContactList(res.data.data);
          setPagination(res.data.count);
        }
      })
      .catch((err) => { });
  };
  const editMobilenumber = () => {
    setshowUserContactDetail(false);
    axios
      .post(
        VeichleBaseUrl + "/UpdateCustomerphonenumber",
        {
          client_id: selectedUser.id,
          phonenumber: editmobilenumber,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setshowUserContactDetail(false);
        if (res.data.status) {
          handelClosemobileeditmodal();
          listContact();
          toast.success(res.data.message, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          handelClosemobileeditmodal();
        } else {
          toast.warning(res.data.message, {
            position: "top-right",
            autoClose: 500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          handelClosemobileeditmodal();
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.warn("", {
          position: "top-right",
          autoClose: 500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
        handelClosemobileeditmodal();
      });
  };
  const getcustomerdetails = () => {
    axios
      .post(
        VeichleBaseUrl + "/Searchcustomer",
        {
          name: debouncedSearch,
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setContactList(res.data.data);
          setPagination(res.data.count);
        } else {
          setContactList([]);
          setPagination(0);
        }
      })
      .catch((err) => { });
  };
  const VeichleDetailsApi = async () => {
    let body = {
      customerNumber: selectedUser.customerNumber,
    };
    await axios
      .post(VeichleBaseUrl + "/Listvechicledetails", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          setveichledetailsdata(res.data.data);
        } else {
          setveichledetailsdata([]);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setveichledetailsdata([]);
      });
  };
  const VeichleDetailsApimodal = async (item) => {
    setveichledetailsdatamodalloader(true);
    let body = {
      id: item._id,
    };
    await axios
      .post(VeichleBaseUrl + "/Listvechicledetailsdetailed", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setveichledetailsdatamodalloader(true);
        if (res.data.status) {
          setveichledetailsdatamodalloader(false);
          setveichledetailsdatamodal(res.data.data);
        } else {
          setveichledetailsdatamodalloader(false);
          setveichledetailsdata([]);
        }
      })
      .catch((error) => {
        setveichledetailsdatamodalloader(false);
        console.log("error", error);
        setveichledetailsdata([]);
      });
  };
  const makeCall = (calledNo, type, id) => {
    localStorage.setItem("callActivate", "true");
    localStorage.setItem("CallMadeFromDcc", "true");
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    props.setDialedNumberInc(calledNo);
    localStorage.setItem("ClickeToCallPhoneNum", calledNo);
    localStorage.setItem("dailedNumber", calledNo);
    axios
      .post(
        AvcUrl +
        `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@demoaccs.com/sip:${calledNo}@${localStorage.getItem(
          "AvayaDomain"
        )}`,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
          },
        }
      )
      .then((res) => {
        if (res.data.statusCode == 500) {
          toast.warn(res.data.status, toaststyle);
        } else if (res.data.status == "OK") {
          localStorage.setItem("type", type);
          localStorage.setItem("ContactVoiceId", id);
          localStorage.setItem("ClickToCall", "true");
        }
      })
      .catch((err) => { });
  };
  const CrmPopup = (phonenumber, userid) => {
    axios
      .post(
        BaseUrl + "/ticket/crmscreenpop",
        {
          phonenumber: phonenumber,
          skillset: "English",
          channel: "webchat",
          callid: userid,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        window.open(res.data.data);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    if (searchvalue.length > 2) {
      getcustomerdetails();
    } else if (searchvalue.length == 0) {
      listContact();
    }

    return () => { };
  }, [debouncedSearch]);

  return (
    <StyledPaper>
      <Box
        sx={{
          height: "calc(100% - 40px)",
          width: "100%",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Grid container>
          {/* contact list  */}
          <Grid item md={3} className="border-end">
            {/* conatct head  */}
            <Stack
              className="p-2 border-bottom"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={0.5}
            >
              {/* conatct title  */}
              <Stack>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#0b3363",
                  }}
                >
                  Customer Details
                </Typography>
              </Stack>
            </Stack>
            {/* contact search list  */}
            <Box className="p-2 cont-search">
              <Box className="nav-item w-100">
                <input
                  autocomplete="off"
                  className="form-control fs-13 bg-light"
                  type="search"
                  name="content"
                  placeholder="Search Customer"
                  aria-label="Search"
                  onChange={(e) => {
                    setsearchvalue(e.target.value);
                  }}
                />
              </Box>
            </Box>
            {/* contact list  */}
            <Box className="p-2 contacts-list fs-13">
              {contactList.length > 0 ? (
                contactList.map((user, index) => {
                  return (
                    <div
                      key={user.id}
                      className={
                        selectedUser
                          ? selectedUser.id == user.id
                            ? "contact active"
                            : "contact"
                          : "contact"
                      }
                      onClick={() => {
                        setselectedUser(user);
                        seteditmobilenumber(user.phonenumber);
                        setshowUserContactDetail(true);
                        setselectedIndex(index);
                        setsetshowEditCustomer(false);
                      }}
                    >
                      <div className="d-flex p-1 justify-content-start align-items-center">
                        <div
                          className="animate__animated animate__slideInUp ticket_round rounded-circle me-3"
                          style={{
                            backgroundColor: randomColors[index],
                          }}
                        >
                          {user
                            ? user.username.trim().slice(0, 2).toUpperCase()
                            : ""}
                        </div>
                        <div className="animate__animated animate__slideInUp">
                          <div className="cont-name">
                            {user ? user.username.toUpperCase() : ""}
                          </div>
                          <div className="text-muted cont-email">
                            <MdCall className="me-1 fs-10" />
                            {user ? user.phonenumber : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-muted d-flex justify-content-center h-100 flex-column">
                  <span className="mx-auto">
                    <img
                      src={Nointeractions2}
                      alt="pic"
                      style={{ width: "11rem", userSelect: "none" }}
                    />
                  </span>
                  <span className="mx-auto">
                    <h6
                      className="text-muted mt-2"
                      style={{ fontSize: "13px" }}
                    >
                      No Contact Found
                    </h6>
                  </span>
                </div>
              )}
            </Box>
            {/* contact footer  */}
            <Stack
              className="p-2 border-top"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                onChange={handleChange}
                shape="rounded"
                color="primary"
                size="small"
              />
            </Stack>
          </Grid>
          {/* contact detail  */}
          <Grid item md={9}>
            {showUserContactDetail ? (
              <Box className="cont-details-main w-100 h-100">
                <Box
                  className="cont-details-hed border-bottom p-2"
                  style={{ width: "100%" }}
                >
                  <Grid container spacing={2}>
                    {/* user details  */}
                    <Grid item xs={9}>
                      <Stack
                        className="ps-2"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={0.5}
                      >
                        <Box>
                          <Avatar
                            className="ticket_round me-2"
                            style={{
                              backgroundColor: randomColors[selectedIndex],
                              fontSize: "18px",
                            }}
                          >
                            {selectedUser
                              ? selectedUser.username
                                .trim()
                                .slice(0, 2)
                                .toUpperCase()
                              : ""}
                          </Avatar>
                        </Box>
                        <Stack
                          direction="column"
                          justifyContent="flex-start"
                          alignItems="flex-start"
                        >
                          <Stack className="fw-bold cont-name">
                            {selectedUser
                              ? selectedUser.username.toUpperCase()
                              : ""}
                          </Stack>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                          >
                            <Box className="text-muted cont-email me-4 fs-13">
                              <MdEmail className="me-2" />
                              {selectedUser ? selectedUser.email : ""}
                            </Box>
                            <Box className="text-muted cont-email fs-13">
                              <MdCall className="me-2" />
                              {selectedUser ? selectedUser.phonenumber : ""}
                            </Box>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>
                    {/* btn right  */}
                    <Grid item xs={3} container justifyContent="flex-end">
                      <Box className="r_action pe-2">
                        <Stack direction="row" spacing={1}>
                          <IconButton
                            aria-label="fingerprint"
                            color="success"
                            sx={{
                              backgroundColor: "#2e7d320a",
                            }}
                            onClick={() => {
                              setwhatsappOpenDialog(true);
                            }}
                          >
                            <IoLogoWhatsapp />
                          </IconButton>
                          <IconButton
                            aria-label="fingerprint"
                            color="primary"
                            sx={{
                              backgroundColor: "#1976d20a",
                            }}
                            onClick={() => {
                              handelOpenmobileeditmodal();
                            }}
                          >
                            <MdModeEdit />
                          </IconButton>
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                {/* Main details and tab  */}
                <div
                  className="cont-detail-sub p-3"
                  style={{ width: "100%", height: "calc(100% - 100px)" }}
                >
                  <ul
                    className="nav nav-pills mb-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="rounded-0 nav-link"
                        style={{
                          backgroundColor:
                            showTab == "Overview"
                              ? randomColors[selectedIndex]
                              : "",
                          color: showTab == "Overview" ? "#ffff" : "#1976D2",
                          boxShadow:
                            showTab == "Overview"
                              ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                              : "",
                        }}
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                        onClick={() => {
                          setshowTab("Overview");
                        }}
                      >
                        Overview
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="rounded-0 nav-link"
                        style={{
                          backgroundColor:
                            showTab == "Ticket"
                              ? randomColors[selectedIndex]
                              : "",
                          color: showTab == "Ticket" ? "#ffff" : "#1976D2",
                          boxShadow:
                            showTab == "Ticket"
                              ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                              : "",
                        }}
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        aria-controls="pills-profile"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={() => {
                          setshowTab("Ticket");
                        }}
                      >
                        Session History
                      </button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button
                        className="rounded-0 nav-link"
                        style={{
                          backgroundColor:
                            showTab == "Vehicledetails"
                              ? randomColors[selectedIndex]
                              : "",
                          color:
                            showTab == "Vehicledetails" ? "#ffff" : "#1976D2",
                          boxShadow:
                            showTab == "Vehicledetails"
                              ? "rgba(0, 0, 0, 0.4) 0px 5px 6px -3px inset"
                              : "",
                        }}
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        aria-controls="pills-profile"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={() => {
                          setshowTab("Vehicledetails");
                        }}
                      >
                        Vehicle Details
                      </button>
                    </li>
                  </ul>
                  {/* tab content  */}
                  <div className="tab-content" id="pills-tabContent">
                    {(() => {
                      switch (showTab) {
                        case "Overview":
                          return (
                            // Overview start here
                            <div
                              className="tab-pane fade show active"
                              id="pills-home"
                              role="tabpanel"
                              aria-labelledby="pills-home-tab"
                            >
                              <div className="cust_view_modal">
                                <div className="row row-cols-3 p-2">
                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <AiOutlineUser size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Username
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.username
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <AiOutlineUserDelete size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Surname
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.surname
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <AiOutlineFieldNumber size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        CustomerNumber
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.customerNumber
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <HiOutlineMail size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Email
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.email : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <HiMiniDevicePhoneMobile size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Mobile
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.Mobile
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      {/* <House size={22} weight="bold" /> */}
                                      <MdOutlinePhone size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Phonenumber
                                      </p>
                                      <p className="text-break mb-0">
                                        {/* {selectedUser
                                              ? selectedUser.phonenumber
                                              : ''} */}
                                        {editmobilenumber}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      {/* <UserCircle size={22} weight="bold" /> */}
                                      <MdOutlinePhone size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Phone Number 2
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.phone2
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <MdOutlinePhone size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Phone Number 3
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.phone3
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <MapPin size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Address
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.address
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <IoMdGlobe size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Country
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.country
                                          : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <TbBuildingBank size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        State
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.state : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <BsBuilding size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        City
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser ? selectedUser.city : ""}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="mb-3 col d-flex align-items-center justify-content-start animate__animated animate__slideInUp">
                                    <div className="cust_icon col-3 bg-white">
                                      <MdOutlineEditLocation size={24} />
                                    </div>
                                    <div className="cust_details_new ps-3 col-9">
                                      <p className="form-label small text-break">
                                        Zip Code
                                      </p>
                                      <p className="text-break mb-0">
                                        {selectedUser
                                          ? selectedUser.pincode
                                          : ""}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            // Overview end here
                          );
                        case "Ticket":
                          return <SessionHistory selectedUser={selectedUser} />;
                        case "Vehicledetails":
                          return (
                            // VEHICLE DETAILS start here
                            <div
                              className="tab-pane fade show active"
                              id="pills-home"
                              role="tabpanel"
                              aria-labelledby="pills-home-tab"
                            >
                              <div className="h-100 overflow-auto">
                                <div className="container-fluid">
                                  <div className="row row-cols-2">
                                    {veichledetailsdata.length > 0 ? (
                                      veichledetailsdata.map((item) => {
                                        return (
                                          <div className="col p-1">
                                            <Card
                                              style={{
                                                fontSize: "10px",
                                              }}
                                            >
                                              <CardContent>
                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    VIN
                                                  </div>
                                                  <div>{item.vin}</div>
                                                </div>
                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    Registration Number
                                                  </div>
                                                  <div>
                                                    {item.RegistrationNumber}
                                                  </div>
                                                </div>
                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    Manufacturer
                                                  </div>
                                                  <div>{item.manufacturer}</div>
                                                </div>
                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    Model No
                                                  </div>
                                                  <div>{item.model}</div>
                                                </div>
                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    Model Year
                                                  </div>
                                                  <div>{item.modelYear}</div>
                                                </div>

                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    Customer Name
                                                  </div>
                                                  <div>
                                                    {item.customerFullName}
                                                  </div>
                                                </div>
                                                <div className="d-flex justify-content-between veichle_info">
                                                  <div className="fw-bold">
                                                    Telephone
                                                  </div>
                                                  <div>
                                                    {item.telephoneNumbers1}
                                                  </div>
                                                </div>

                                                <div className="w-100 d-flex justify-content-end my-1">
                                                  {/* <BootstrapTooltip
                                                  title="View Details"
                                                  arrow
                                                  placement="top"
                                                > */}
                                                  <Button
                                                    style={{
                                                      fontSize: "10px",
                                                      textTransform:
                                                        "capitalize",
                                                      backgroundColor:
                                                        showTab ==
                                                          "Vehicledetails"
                                                          ? randomColors[
                                                          selectedIndex
                                                          ]
                                                          : "",
                                                      color:
                                                        showTab ==
                                                          "Vehicledetails"
                                                          ? "#ffff"
                                                          : "#1976D2",
                                                    }}
                                                    onClick={() => {
                                                      handleShow();
                                                      VeichleDetailsApimodal(
                                                        item
                                                      );
                                                    }}
                                                    variant="contained"
                                                    size="small"
                                                    disableElevation
                                                  >
                                                    <FaRegEye
                                                      color="white"
                                                      className="me-2"
                                                    />
                                                    Open Full List
                                                  </Button>
                                                  {/* </BootstrapTooltip> */}
                                                </div>
                                              </CardContent>
                                            </Card>
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <div className="col-md-12">
                                        <Stack
                                          style={{
                                            height: "50vh",
                                          }}
                                          className="p-2"
                                          direction="column"
                                          justifyContent="center"
                                          alignContent="center"
                                        >
                                          {/* // Data unavailable start */}
                                          <Stack
                                            className="text-muted"
                                            direction="column"
                                            justifyContent="center"
                                            alignContent="center"
                                          >
                                            <span className="mx-auto">
                                              <img
                                                src={Nodata}
                                                alt="pic"
                                                style={{
                                                  width: "11rem",
                                                  userSelect: "none",
                                                }}
                                              />
                                            </span>
                                            <span className="mx-auto">
                                              <h6
                                                className="text-muted mt-3"
                                                style={{ fontSize: "13px" }}
                                              >
                                                Data unavailable
                                              </h6>
                                            </span>
                                          </Stack>
                                          {/* // Data unavailable end */}
                                        </Stack>
                                      </div>
                                    )}
                                  </div>
                                  {/* Vehicle Details start here  */}
                                  <Modal
                                    show={show}
                                    onHide={handleClose}
                                    size="md"
                                  >
                                    <Modal.Header
                                      style={{
                                        height: "40px",
                                        // backgroundColor: "#0b3364",
                                        backgroundColor:
                                          showTab == "Vehicledetails"
                                            ? randomColors[selectedIndex]
                                            : "",
                                        color:
                                          showTab == "Vehicledetails"
                                            ? "#ffff"
                                            : "#1976D2",
                                      }}
                                    >
                                      <Modal.Title
                                        className="text-white"
                                        style={{ fontSize: "14px" }}
                                      >
                                        Vehicle Details
                                      </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body
                                      style={{
                                        height: "75vh",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {veichledetailsdatamodalloader ? (
                                        <div className=" h-100 d-flex justify-content-center align-items-center">
                                          <Spinner
                                            style={{
                                              color:
                                                showTab == "Vehicledetails"
                                                  ? randomColors[selectedIndex]
                                                  : "",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          className="modal_body"
                                          style={{
                                            height: "72vh",
                                            overflowY: "auto",
                                          }}
                                        >
                                          <div className="d-flex justify-content-between mx-auto">
                                            <p className="fw-bold">VIN</p>
                                            <p className="d-flex justify-content-end">
                                              {veichledetailsdatamodal.vin ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.vin}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Registration Number
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.RegistrationNumber ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.RegistrationNumber}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Registration Date
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.registrationDate ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.registrationDate}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Description
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.description ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.description}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Last Service Date
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.lastServiceDate ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.lastServiceDate}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">Odometer</p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.odometerAtLastWork ==
                                                ""
                                                ? "--"
                                                : veichledetailsdatamodal.odometerAtLastWork}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Color Code
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.colorCode ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.colorCode}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Color Description
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.colorDescription ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.colorDescription}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">Trim Code</p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.trimCode ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.trimCode}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Trim Description
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.trimDescription ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.trimDescription}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">Title</p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.title ==
                                                ""
                                                ? "--"
                                                : veichledetailsdatamodal.title}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Model Year
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.modelYear ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.modelYear}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Customer Number
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.customerNumber ==
                                                ""
                                                ? "--"
                                                : veichledetailsdatamodal.customerNumber}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Customer FullName
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.customerFullName ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.customerFullName}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Teliphone Number1
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.telephoneNumbers1 ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.telephoneNumbers1}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Teliphone Number2
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.telephoneNumbers2 ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.telephoneNumbers2}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Teliphone Number3
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.telephoneNumbers3 ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.telephoneNumbers3}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Teliphone Number4
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.telephoneNumbers4 ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.telephoneNumbers4}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">Job Title</p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.jobTitle ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.jobTitle}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Selling Branch
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.sellingBranch ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.sellingBranch}
                                            </p>
                                          </div>

                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Sales Branch Name
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.salesBranchName ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.salesBranchName}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">SE Name</p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.seName ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.seName}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Vehicle Selling Date
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.vehicleSellingDate ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.vehicleSellingDate}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Vehicle Type
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.vehicleType ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.vehicleType}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Aftersales Branch
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.aftersalesBranch ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.aftersalesBranch}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Aftersales Branch Name
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.aftersalesBranchName ==
                                                " "
                                                ? ""
                                                : veichledetailsdatamodal.aftersalesBranchName}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">Gender</p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.gender ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.gender}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Business Type
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {veichledetailsdatamodal.businessType ==
                                                " "
                                                ? "--"
                                                : veichledetailsdatamodal.businessType}
                                            </p>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                            <p className="fw-bold">
                                              Nationality Code
                                            </p>
                                            <p className="d-flex d-flex justify-content-end">
                                              {
                                                veichledetailsdatamodal.nationalityCode
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </Modal.Body>

                                    <div className="w-100 d-flex justify-content-end p-2 px-2">
                                      <Button
                                        disableElevation
                                        variant="contained"
                                        size="small"
                                        onClick={handleClose}
                                        color="error"
                                      >
                                        Close
                                      </Button>
                                    </div>
                                  </Modal>
                                  {/* Vehicle Details start here  */}
                                </div>
                              </div>
                            </div>
                            // VEHICLE DETAILS end here
                          );
                        default:
                          return <></>;
                      }
                    })()}
                  </div>
                </div>
              </Box>
            ) : (
              // User not found start
              <div className="text-muted d-flex justify-content-center h-100 flex-column">
                <span className="mx-auto">
                  <img
                    src={NoSelectContact}
                    alt="pic"
                    style={{ width: "20rem", userSelect: "none" }}
                  />
                </span>
                <span className="mx-auto">
                  <h6 className="text-muted mt-2" style={{ fontSize: "13px" }}>
                    User information unavailable
                  </h6>
                </span>
              </div>
              // User not found end
            )}
          </Grid>
        </Grid>
      </Box>

      {/* <AddCustomer
        showAddCustomer={showAddCustomer}
        setshowAddCustomer={setshowAddCustomer}
        listContact={listContact}
      /> */}
      {/* <EditCustomer
        showEditCustomer={showEditCustomer}
        setsetshowEditCustomer={setsetshowEditCustomer}
        listContact={listContact}
        selectedUser={selectedUser}
        setselectedUser={setselectedUser}
        setshowUserContactDetail={setshowUserContactDetail}
      /> */}

      {/* whatsappOpenDialog start here  */}
      {whatsappOpenDialog && (
        <WhatsAppInitDialogBox
          whatsappOpenDialog={whatsappOpenDialog}
          whatsappDialogClose={whatsappDialogClose}
          selectedUser={selectedUser}
        />
      )}

      {/* edit customer start  */}
      <Drawer
        anchor="right"
        open={mobileeditmodal}
        onClose={handelClosemobileeditmodal}
      >
        <Box
          sx={{
            width: "20rem",
          }}
        >
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Edit Customer
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form>
              <div className="row row-cols-1">
                <div className="mb-3 d-flex flex-column text-start">
                  <label className="form-label">
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    className="form-control"
                    placeholder="Edit Phone Number"
                    value={editmobilenumber}
                    onChange={(e) => seteditmobilenumber(e.target.value)}
                  />
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={handelClosemobileeditmodal}
            >
              Close
            </Button>
            <Button
              form="form1"
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              onClick={editMobilenumber}
            >
              Update
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* edit customer end  */}
    </StyledPaper>
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(
  CustomerDetails
);
